/* src/app/shared/category/category.component.scss */
.category-group {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}
.category-item {
  min-width: 16em;
  border-radius: 4px;
  box-shadow: none;
}
@media (min-width: 1790px) {
  .category-group {
    padding-right: 2em;
  }
  .category-group .category-item {
    min-width: 18em;
    padding-right: 1em;
  }
}
/*# sourceMappingURL=category.component.css.map */
